import React, { FC } from 'react'
import Button from '@material-ui/core/Button'
import { FormattedMessage } from 'react-intl'
import { Grid, Typography } from '@material-ui/core'
import ResponsiveModal, { ModalSizes } from '@src/components/ResponsiveModal'
import {
  ResponsiveModalBody,
  ResponsiveModalActions,
} from '@src/components/ResponsiveModal/ResponsiveModal'

interface CautionPopupMTORedesignProps {
  dialogOpen: boolean
  handleClose: () => void
  handleContinue: () => Promise<void>
}

const CautionPopupMTORedesign: FC<CautionPopupMTORedesignProps> = ({
  dialogOpen,
  handleClose,
  handleContinue,
}) => {
  return (
    <ResponsiveModal
      open={dialogOpen}
      onClose={handleClose}
      size={ModalSizes.Small}
      renderTitle={() => (
        <Typography variant="h2" component="h2">
          <FormattedMessage
            id="CONF_CAUTION_HEADING"
            defaultMessage="Caution"
          />
        </Typography>
      )}
    >
      <ResponsiveModalBody>
        <Grid container>
          <Grid item xs={12}>
            <FormattedMessage
              id="CONF_CAUTION_POPUP_TEXT_TUBES"
              defaultMessage="Adding a new set of items will override any existing items in this session."
            />
          </Grid>
          <Grid item xs={12}>
            <FormattedMessage
              id="CONF_CAUTION_POPUP_TEXT_TUBES_CONTINUE_QUESTION"
              defaultMessage="Do you wish to continue with a new session?"
            />
          </Grid>
        </Grid>
        <ResponsiveModalActions>
          <Button
            onClick={handleClose}
            color="primary"
            id="caution-cancel-button"
            data-testid="caution-cancel-button"
            variant="outlined"
          >
            <FormattedMessage id="CANCEL" defaultMessage="Cancel" />
          </Button>
          <Button
            onClick={handleContinue}
            color="primary"
            variant="contained"
            id="continue-confirm-button"
            data-testid="continue-confirm-button"
          >
            <FormattedMessage id="CONTINUE" defaultMessage="Continue" />
          </Button>
        </ResponsiveModalActions>
      </ResponsiveModalBody>
    </ResponsiveModal>
  )
}

export default CautionPopupMTORedesign
